import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import { USER_INTERACTION_DATA_ATTRIBUTE } from "@shared/constants";

interface ButtonClassProps extends React.HTMLAttributes<HTMLElement> {
  chevron?: boolean;
  color?: "action" | "primary-light" | "primary" | "secondary";
  componentStyle?: "default" | "inverted";
  iconRight?: React.ReactNode;
  size?: "default" | "small";
  variant?: "transparent" | "outlined" | "solid";
}

export interface CommonButtonProps extends ButtonClassProps {
  text?: string;
  [USER_INTERACTION_DATA_ATTRIBUTE]?: string;
}

export function createButtonClassNames({
  className,
  color,
  componentStyle,
  iconRight,
  size,
  variant,
}: ButtonClassProps) {
  return clsx(
    {
      [`button-new`]: true,
      [`button-new--is-action`]: !color || color === "action",
      [`button-new--is-neutral`]: color === "primary-light",
      [`button-new--is-primary`]: color === "primary",
      [`button-new--is-secondary`]: color === "secondary",
      [`button-new--is-transparent`]: variant === "transparent",
      [`button-new--is-outlined`]: variant === "outlined",
      [`button-new--is-solid`]: !variant || variant === "solid",
      [`button-new--is-small`]: size === "small",
      [`button-new--has-icon-right`]: iconRight,
      [`button-new--is-inverted`]: componentStyle === "inverted",
    },
    className,
  );
}

export function determineIcon({
  chevron,
  iconRight,
}: ButtonClassProps): React.ReactNode {
  if (!chevron && !iconRight) return;

  if (iconRight) {
    return iconRight;
  }
  if (chevron) {
    return <FontAwesomeIcon icon={faChevronRight} />;
  }
  return;
}

interface ButtonContentProps {
  icon?: React.ReactNode;
  text: string;
  iconLeftBandaid?: boolean;
}

export function ButtonContent({
  icon,
  text,
  iconLeftBandaid,
}: ButtonContentProps) {
  return (
    <span className="button-new__content">
      <span
        className="button-new__text"
        dangerouslySetInnerHTML={{ __html: text || "" }}
      />
      {icon && !iconLeftBandaid && (
        <span className="button-new__icon">{icon}</span>
      )}
    </span>
  );
}
